import React from "react";
import { Button, Container, Navbar, Spinner } from "react-bootstrap";

function TNavbar({
  domain,
  hasChanged,
  handleDiscard,
  handlePublish,
  isTrial,
  isPublishing,
  isDiscarding,
  filename,
  leftControls,
  logoSrc,
  isSaving,
  pickerMessage,
}) {
  const isBusy = isPublishing || isSaving || isDiscarding;

  return (
    <>
      <Navbar
        variant="dark"
        expand="lg"
        className="box-shadow sticky-top app-navbar"
      >
        <Container fluid className="app-navbar-container">
          <div className="app-navbar-left">
            {leftControls}
            {pickerMessage && (
              <div className="picker-message">{pickerMessage}</div>
            )}
          </div>

          <div className="app-navbar-center">
            {logoSrc && (
              <img src={logoSrc} alt="Logo" className="app-navbar-logo" />
            )}
          </div>

          <Navbar id="basic-navbar-nav" className="app-navbar-right">
            {!hasChanged ? (
              <Button
                href={`https://${domain}${filename || "/"}`}
                target="_blank"
                className="nav-pill-btn nav-pill-btn-ghost"
                variant="light"
              >
                View Website
              </Button>
            ) : (
              <>
                <Button
                  variant="light"
                  className="nav-pill-btn nav-pill-btn-ghost"
                  onClick={handleDiscard}
                  disabled={isPublishing || isDiscarding}
                >
                  Discard
                </Button>
                <Button
                  variant="light"
                  className="nav-pill-btn nav-pill-btn-primary"
                  onClick={handlePublish}
                  disabled={isPublishing || isSaving || isDiscarding}
                >
                  Publish
                </Button>
              </>
            )}
            {isBusy && (
              <Spinner
                animation="border"
                role="status"
                variant="light"
                className="ms-2"
              >
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </Navbar>
        </Container>
      </Navbar>

      {hasChanged && (
        <div className="mobile-fixed-actions" aria-label="Mobile edit actions">
          <Button
            variant="light"
            className="nav-pill-btn nav-pill-btn-ghost mobile-fixed-action-btn"
            onClick={handleDiscard}
            disabled={isPublishing || isDiscarding}
          >
            Discard
          </Button>

          <Button
            variant="light"
            className="nav-pill-btn nav-pill-btn-primary mobile-fixed-action-btn"
            onClick={handlePublish}
            disabled={isPublishing || isSaving || isDiscarding}
          >
            {isBusy ? "Publishing..." : "Publish"}
          </Button>
        </div>
      )}
    </>
  );
}

export default TNavbar;
